var _g, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 99,
    viewBox: "0 0 113 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6001 42.5036C7.35222 42.5036 4.7193 39.8991 4.7193 36.6862L4.7193 16.3041C4.7193 13.0912 7.35222 10.4867 10.6001 10.4867C13.8479 10.4867 16.4809 13.0912 16.4809 16.3041L16.4809 36.6862C16.4809 39.8991 13.8479 42.5036 10.6001 42.5036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.84332C15 2.63045 17.6329 0.0259094 20.8808 0.0259094L41.4849 0.0259094C44.7328 0.0259094 47.3657 2.63045 47.3657 5.84332C47.3657 9.05619 44.7328 11.6607 41.4849 11.6607L20.8808 11.6607C17.6329 11.6607 15 9.05619 15 5.84332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2941 84.9602C15.2941 81.7473 17.927 79.1428 21.1748 79.1428H41.779C45.0268 79.1428 47.6597 81.7473 47.6597 84.9602C47.6597 88.173 45.0268 90.7776 41.779 90.7776H21.1748C17.927 90.7776 15.2941 88.173 15.2941 84.9602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 45.682C15 42.4692 17.6329 39.8646 20.8808 39.8646H41.4849C44.7328 39.8646 47.3657 42.4692 47.3657 45.682C47.3657 48.8949 44.7328 51.4995 41.4849 51.4995H20.8808C17.6329 51.4995 15 48.8949 15 45.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6001 82.3635C7.35222 82.3635 4.7193 79.7589 4.7193 76.5461L4.7193 56.164C4.7193 52.9511 7.35222 50.3465 10.6001 50.3465C13.8479 50.3465 16.4809 52.9511 16.4809 56.164L16.4809 76.5461C16.4809 79.7589 13.8479 82.3635 10.6001 82.3635Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.887 85.47C105.482 85.47 103.533 83.4993 103.533 81.0682V65.6461C103.533 63.215 105.482 61.2443 107.887 61.2443C110.292 61.2443 112.241 63.215 112.241 65.6461V81.0682C112.241 83.4993 110.292 85.47 107.887 85.47Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.887 55.5301C105.482 55.5301 103.533 53.5593 103.533 51.1283V35.7061C103.533 33.2751 105.482 31.3044 107.887 31.3044C110.292 31.3044 112.241 33.2751 112.241 35.7061V51.1283C112.241 53.5593 110.292 55.5301 107.887 55.5301Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2045 85.47C71.7997 85.47 69.8502 83.4993 69.8502 81.0682V65.6461C69.8502 63.215 71.7997 61.2443 74.2045 61.2443C76.6094 61.2443 78.5589 63.215 78.5589 65.6461V81.0682C78.5589 83.4993 76.6094 85.47 74.2045 85.47Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.307 86.4232C79.307 84.0184 81.2777 82.0689 83.7088 82.0689H99.1309C101.562 82.0689 103.533 84.0184 103.533 86.4232C103.533 88.828 101.562 90.7775 99.1309 90.7775H83.7088C81.2777 90.7775 79.307 88.828 79.307 86.4232Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.307 60.0795C79.307 57.6747 81.2777 55.7252 83.7088 55.7252L99.1309 55.7252C101.562 55.7252 103.533 57.6747 103.533 60.0795C103.533 62.4843 101.562 64.4338 99.1309 64.4338H83.7088C81.2777 64.4338 79.307 62.4843 79.307 60.0795Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.719299,
    y: 0.0259094,
    width: 58.2807,
    height: 98.7517,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdIcon);
export default __webpack_public_path__ + "static/media/edIcon.8cd97e6da5570605110f3522696ae6cc.svg";
export { ForwardRef as ReactComponent };